import React from 'react';

interface CardProps {
  title?: string;
  className?: string;
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, className = '', children }) => {
  return (
    <section className={`rounded-[2rem] bg-white shadow-sm border border-slate-100 p-4 md:p-6 dark:bg-slate-800 dark:border-slate-700 ${className}`}>
      {title && <h3 className="text-lg font-semibold ell-2 ui-wrap mb-4 text-slate-900 dark:text-slate-100" title={title}>{title}</h3>}
      <div className="min-w-0">{children}</div>
    </section>
  );
};

export default Card;
